import { render, staticRenderFns } from "./StatisticPage.vue?vue&type=template&id=54b6138a&scoped=true"
import script from "./StatisticPage.vue?vue&type=script&lang=js"
export * from "./StatisticPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticPage.vue?vue&type=style&index=0&id=54b6138a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6138a",
  null
  
)

export default component.exports